import * as React from "react"
import FlywheelColor from "../svgs/components/Flywheel-color-logo-RGB"
import FlywheelWhite from "../svgs/components/Flywheel-white-logo-RGB"
import Breadcrumb from "./breadcrumbs"
import { Link } from "gatsby"

const FlywheelCompany = (props) => {

    let marginClassFirst = ''
    let marginClassSecond = ''
    let gutterClass = 'g-4'
    if(props.location !== undefined) {
        marginClassFirst = 'pb-md-6 pt-6'
        marginClassSecond = 'py-6'
        gutterClass = ''
    }
        
    return(
        <div data-sal="slide-up" data-sal-delay="400" data-sal-duration='800' data-sal-easing="ease" className='container' id='ascential-company'>
            {props.location !== undefined ?
                <Breadcrumb location={props.location} />
            :
                <></>
            }
            <div className={`row ${gutterClass}`}>
                <div className={`col-md-6 col-12 ${marginClassFirst}`}>
                    <div className=' h-100'>
                        <div className='card-body'>
                            {props.white === true ?
                            <>
                                <h1 className='text-white text-uppercase mb-4'>WhyteSpyder is Now Flywheel Digital.</h1>
                                <p className='text-white font-md mb-0'>We provide Walmart and omnichannel solutions for the world’s largest brands as Flywheel, setting the standard for digital commerce across the globe.</p>
                            </>
                            :
                            <>
                                <h1 className='text-dark text-uppercase mb-4'>WhyteSpyder is Now Flywheel Digital.</h1>
                                <p className='text-header font-md mb-0'>We provide Walmart and omnichannel solutions for the world’s largest brands as Flywheel, setting the standard for digital commerce across the globe.</p>
                            </>
                            }
                        </div>
                    </div>
                </div>
                <Link to={'https://www.flywheeldigital.com/full-service-commerce-solution#walmart'} className={`col-md-6 col-12 d-flex ${marginClassSecond}`}>
                    {props.white === true ?
                        <div className='w-100 m-auto text-white'>
                            <FlywheelWhite/>
                        </div>
                    :
                        <div className='w-100 m-auto'>
                            <FlywheelColor/>
                        </div>
                    }
                </Link>
            </div>
        </div>
    )
}

export default FlywheelCompany;